import { Directive, ElementRef, HostListener, Input, NgModule } from '@angular/core';
import { MaskingBase } from 'racoon-mask-base';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class InputMaskDirective extends MaskingBase {
    /**
     * @param {?} el
     */
    constructor(el) {
        super();
        this.el = el;
        this._input = el.nativeElement;
    }
    /**
     * @param {?} input
     * @return {?}
     */
    set input(input) {
        this._input = input.nativeElement;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set slotChar(value) {
        this._slotChar = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set showPlaceholder(value) {
        this._showPlaceholder = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set mask(value) {
        this._mask = value;
    }
    /**
     * @return {?}
     */
    onInput() {
        if (this.update) {
            this.update = false;
            return;
        }
        this.checkValue();
    }
    /**
     * @return {?}
     */
    onBlur() {
        this.blurEvent();
    }
    /**
     * @return {?}
     */
    onFocus() {
        this.checkValue(true);
    }
    /**
     * @return {?}
     */
    updateInput() {
        super.updateInput();
        this.update = true;
        this._input.dispatchEvent(new Event("input"));
    }
}
InputMaskDirective.ɵfac = function InputMaskDirective_Factory(t) { return new (t || InputMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
InputMaskDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: InputMaskDirective, selectors: [["", "rInputMask", ""]], hostBindings: function InputMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function InputMaskDirective_input_HostBindingHandler() { return ctx.onInput(); })("blur", function InputMaskDirective_blur_HostBindingHandler() { return ctx.onBlur(); })("focus", function InputMaskDirective_focus_HostBindingHandler() { return ctx.onFocus(); });
    } }, inputs: { input: "input", slotChar: "slotChar", showPlaceholder: "showPlaceholder", mask: ["rInputMask", "mask"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
InputMaskDirective.ctorParameters = () => [
    { type: ElementRef }
];
InputMaskDirective.propDecorators = {
    input: [{ type: Input }],
    slotChar: [{ type: Input }],
    showPlaceholder: [{ type: Input }],
    mask: [{ type: Input, args: ["rInputMask",] }],
    onInput: [{ type: HostListener, args: ["input",] }],
    onBlur: [{ type: HostListener, args: ["blur",] }],
    onFocus: [{ type: HostListener, args: ["focus",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InputMaskDirective, [{
        type: Directive,
        args: [{
                selector: "[rInputMask]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { input: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], showPlaceholder: [{
            type: Input
        }], mask: [{
            type: Input,
            args: ["rInputMask"]
        }], onInput: [{
            type: HostListener,
            args: ["input"]
        }], onBlur: [{
            type: HostListener,
            args: ["blur"]
        }], onFocus: [{
            type: HostListener,
            args: ["focus"]
        }] }); })();
class InputMaskModule {
}
InputMaskModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: InputMaskModule });
InputMaskModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function InputMaskModule_Factory(t) { return new (t || InputMaskModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputMaskModule, { declarations: [InputMaskDirective], exports: [InputMaskDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InputMaskModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    InputMaskDirective
                ],
                exports: [
                    InputMaskDirective
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { InputMaskDirective, InputMaskModule };

//# sourceMappingURL=racoon-mask-raw.js.map